import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var ReloadOutlineIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { d: "M20.484 6.875l-1.383 2.463C17.997 5.672 14.67 3 10.747 3 5.924 3 2 7.037 2 12s3.924 9 8.746 9v-1.8c-3.858 0-6.997-3.23-6.997-7.2s3.14-7.2 6.997-7.2c3.297 0 6.06 2.36 6.798 5.522L14.51 8.521l-.875 1.56 5.303 3.15L22 7.773l-1.516-.9z", fill: "currentColor" })] })));
};

export { ReloadOutlineIcon };
//# sourceMappingURL=ReloadOutlineIcon.js.map
